import React from 'react';

import cx from 'classnames';
import styles from './pipedriveConfigurationView.module.scss';
import { toast } from 'react-toastify';
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import { 
  Row, Col, FormGroup, InputGroup, FormControl, Form
} from 'react-bootstrap';

import SwitchButton from 'src/components/switchButton';
import SendButton from 'src/legacy/components/SendButton';
import PlaceholderEmptyMessage from 'src/legacy/components/PlaceholderEmptyMessage';

import AccessDeniedIcon from 'src/legacy/images/access_denied.svg';
import _ from 'lodash';
import { localizedStrings } from 'src/localization/index.jsx';
import Toast from 'src/components/toast';

class PipedriveConfigurationView extends React.Component {
  constructor(props){
    super(props);
    const integration = this.props.integration;

    this.state = {
      email: integration && integration.configuration.email || '',
      companyDomain: integration && integration.configuration.companyDomain || '',
      syncReadAssetEvent: integration && integration.configuration.syncReadAssetEvent || false,
      syncReadConversationEvent: integration && integration.configuration.syncReadConversationEvent || false,
      syncReshareConversationEvent: integration && integration.configuration.syncReshareConversationEvent || false,
      syncLeadCreatedEvent: integration && integration.configuration.syncLeadCreatedEvent || false,
      syncDeals: integration && integration.configuration.syncDeals || false,
      syncAssetDownloadEvent: integration && integration.configuration.syncAssetDownloadEvent || false,
      errors: {}
    }

    this._toggleSwitchChange = this._toggleSwitchChange.bind(this);
    this._handleSaveChangesClicked = this._handleSaveChangesClicked.bind(this);
    this._handleResetClicked = this._handleResetClicked.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedPipedrive = localizedStrings.components.integrations.pipedrive;
  }

  componentDidMount() {   
  }

  _toggleSwitchChange(field){

    this.setState({
      [field]: !this.state[field]
    });
  }

  _handleSaveChangesClicked(){
  
    let request = {
      syncReadAssetEvent: this.state.syncReadAssetEvent,
      syncReadConversationEvent: this.state.syncReadConversationEvent,
      syncReshareConversationEvent: this.state.syncReshareConversationEvent,
      syncLeadCreatedEvent: this.state.syncLeadCreatedEvent,
      syncDeals: this.state.syncDeals,
      syncAssetDownloadEvent: this.state.syncAssetDownloadEvent
    }

    this.props.updateConfiguration(request).then(() => {
        toast(
          <Toast.Sucess
            message = {this.localizedIntegrations.toast.pipedrive}            
          /> , {
            autoClose: 3000,
        })
    });
  }

  _handleResetClicked(){
    this.setState({
      syncReadAssetEvent: this.props.integration.configuration.syncReadAssetEvent,
      syncReadConversationEvent: this.props.integration.configuration.syncReadConversationEvent,
      syncReshareConversationEvent: this.props.integration.configuration.syncReshareConversationEvent,
      syncLeadCreatedEvent: this.props.integration.configuration.syncLeadCreatedEvent,
      syncDeals: this.props.integration.configuration.syncDeals,
      syncAssetDownloadEvent: this.props.integration.configuration.syncAssetDownloadEvent
    });
  }

  render(){
    return (
      <div className={styles.content}>
        {this.props.integration && this.props.integration.state.code === "auth_error" &&
          <span className={styles.authMessage}>
            {`${this.localizedIntegrations.integration_expired} ${this.props.integration.type}.`}
          </span>
        }

        {this.props.loading && this._renderLoading()}

        {!this.props.loading && this._renderAdminConfiguration()}

      </div>
    )
  }

  _renderAdminConfiguration() {
    return (
        <Row className={styles.row}>
          <Col md={8} mdOffset={1}>
            <div className={styles.form}>
              <p className={styles.errorMessage}>{this.state.errors && this.state.errors.apikey}</p>
              <FormGroup className={cx(styles.formGroup)}>
              <InputGroup className = {styles.disableEmail}>
                <InputGroup.Text className={styles.start}>
                  <span>{ this.localizedPipedrive.configuration.domain_name }</span>
                </InputGroup.Text>
                <FormControl
                  type='text'
                  placeholder=""
                  value={this.state.companyDomain}
                  disabled/>
                <InputGroup.Text className={styles.end}>
                  <span>.pipedrive.com</span>
                </InputGroup.Text>
              </InputGroup>
              </FormGroup>
              <Form.Text>{ this.localizedPipedrive.configuration.active }</Form.Text>
              
              <FormGroup className={cx(styles.formGroup)}>
              <InputGroup className = {styles.disableEmail}>
                <InputGroup.Text className={styles.start}>
                  <span>{ this.localizedCommons.email }</span>
                </InputGroup.Text>
                <FormControl
                  type='text'
                  placeholder=""
                  value={this.state.email}
                  disabled/>
              </InputGroup>
              </FormGroup>
              <Form.Text>{ this.localizedPipedrive.configuration.email_active }</Form.Text>


              <FormGroup className={cx(styles.formGroup)}>
                <InputGroup>
                  <h5>{ this.localizedIntegrations.sync_events }</h5>
                </InputGroup>
              </FormGroup>
              <Form.Text>{ this.localizedPipedrive.configuration.sync_events.sub_text }</Form.Text>

              <FormGroup className={cx(styles.formGroup, styles.events)}>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.view_asset }</label>
                  <SwitchButton 
                    id="syncReadAssetEvent"
                    className={styles.switch}
                    checked={this.state.syncReadAssetEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncReadAssetEvent")} />
                </div>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.view_collection }</label>
                  <SwitchButton 
                    className={styles.switch}
                    id="syncReadConversationEvent"
                    checked={this.state.syncReadConversationEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncReadConversationEvent")} />
                </div>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.reshare_collection }</label>
                  <SwitchButton 
                    className={styles.switch}
                    id="syncReshareConversationEvent"
                    checked={this.state.syncReshareConversationEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncReshareConversationEvent")} />
                </div>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.create_lead }</label>
                  <SwitchButton 
                    className={styles.switch}
                    id="syncLeadCreatedEvent"
                    checked={this.state.syncLeadCreatedEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncLeadCreatedEvent")} />
                </div>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.download_asset }</label>
                  <SwitchButton 
                    className={styles.switch}
                    id="syncAssetDownloadEvent"
                    checked={this.state.syncAssetDownloadEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncAssetDownloadEvent")} />
                </div>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.sync_deals }</label>
                  <SwitchButton 
                    id="syncDeals"
                    className={styles.switch}
                    checked={this.state.syncDeals}
                    handleCheck={()=>this._toggleSwitchChange("syncDeals")} />
                </div>
              </FormGroup>


              <div className={styles.buttonTray}>
                <SendButton
                  className={cx(styles.save)}
                  icon="fa-chevron-right"
                  title={this.props.updating ? `${this.localizedCommons.actions.saving_changes}...` : this.localizedCommons.actions.save }
                  primary
                  disabled={this.props.updating}
                  onClick={this._handleSaveChangesClicked}
                >
                </SendButton>
                <SendButton
                  title={this.localizedCommons.actions.reset}
                  disabled={this.props.updating}
                  className={cx(styles.cancel)}
                  onClick={this._handleResetClicked}
                >
                </SendButton>
              </div>
            </div>
          </Col>
        </Row>
    );
  }

  _renderEmptyMessage() {
    return (
      <PlaceholderEmptyMessage
        title={this.localizedPipedrive.configuration.empty_message.title}
        message={this.localizedPipedrive.configuration.empty_message.sub_text}
        image={AccessDeniedIcon}
        className={styles.emptyMessage}
        visible={true}
      />
    );
  }

  _renderLoading() {
    return (
      <LoadingMessage 
        className={styles.loadingMessage}
        message={this.localizedPipedrive.configuration.loading}
        visible={true} />
    )
  }
}

export default PipedriveConfigurationView;